module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/fac-step1-203ae2098ff2e44a9fa0927d6a8a31cf.svg";